import { ENGLISH_LANG_CODE } from "@evennt-tech/api-v2-core";
import { resolveActiveLanguage } from "tools/localization/resolveActiveLanguage";

/**
 * The language a shared Show Info link opens in (FS-3279): the link's own
 * language for an exhibitor who reads in it, the Show's default for an
 * exhibitor with no language and for anyone else, and English (the system
 * language) for an exhibitor who reads in another one.
 */
export const resolveStandaloneLanguage = ({
  exhibitorLanguage,
  linkLanguage,
  showDefaultLanguage,
  availableCodes,
}: {
  exhibitorLanguage?: string;
  linkLanguage?: string;
  showDefaultLanguage?: string;
  availableCodes: string[];
}): string => {
  let preferred = showDefaultLanguage;
  if (exhibitorLanguage) {
    preferred =
      exhibitorLanguage === linkLanguage
        ? exhibitorLanguage
        : ENGLISH_LANG_CODE;
  }

  return resolveActiveLanguage({
    preferred,
    availableCodes,
    showDefaultLanguage,
  });
};
